var _desc, _path, _circle, _circle2, _text, _text2, _text3, _text4, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDirectionsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Directions Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Navigation and directions icon")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 50 L60 30 L55 50 L60 70 Z",
    fill: "#5F7A61",
    stroke: "#E5DECF",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 35,
    fill: "none",
    stroke: "#E5DECF",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30,
    fill: "none",
    stroke: "#F5F0E6",
    strokeWidth: 1
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 25,
    textAnchor: "middle",
    fill: "#E5DECF",
    fontSize: 10,
    fontWeight: "bold"
  }, "N")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 75,
    y: 55,
    textAnchor: "middle",
    fill: "#E5DECF",
    fontSize: 10,
    fontWeight: "bold"
  }, "E")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 82,
    textAnchor: "middle",
    fill: "#E5DECF",
    fontSize: 10,
    fontWeight: "bold"
  }, "S")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 25,
    y: 55,
    textAnchor: "middle",
    fill: "#E5DECF",
    fontSize: 10,
    fontWeight: "bold"
  }, "W")), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 3,
    fill: "#5F7A61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectionsIcon);
export default __webpack_public_path__ + "static/media/directions-icon.ac9a05e32c61c6ff5e4679c6eda5d35e.svg";
export { ForwardRef as ReactComponent };